import axios from "axios";
import React, {useState, useEffect} from "react";
import { Modal, Button } from "react-bootstrap";

interface SubscriptionNotificationProps {
    subscriptions: Array<AstraModemSubscription>;
}

const SubscriptionNotification: React.FC<SubscriptionNotificationProps> = ({subscriptions}) => {
    const daysLeftForWarning = 10;

    const [isAstra, setIsAstra] = useState(process.env.REACT_APP_SERVICE == 'astra');
    const [subscriptionEnding, setSubscriptionEnding] = useState<Array<AstraModemSubscription>>();
    const [subscriptionExpire, setSubscriptionExpire] = useState<Array<AstraModemSubscription>>();
    const [showWarning, setShowWarning] = useState(false);

    useEffect(() => {
        if(isAstra) {
            let ending = subscriptions?.filter(x => x.daysLeft < daysLeftForWarning && x.daysLeft > 0);
            let expire = subscriptions?.filter(x => x.daysLeft <= 0);
            setSubscriptionEnding(ending)
            setSubscriptionExpire(expire)
            if(ending.length > 0 || expire.length > 0) {
                setShowWarning(true);
            }
        }    
    }, [isAstra, subscriptions]);

    return(
        <>
            {isAstra ? 
            <>
                <Modal  show={showWarning} onHide={() => {setShowWarning(false)}}>
                    <Modal.Header closeButton>
                    <Modal.Title style={{color: "black"}}>Внимание</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{color: "black"}}>
                        {subscriptionExpire && subscriptionEnding &&
                            <>
                                { subscriptionEnding?.length > 0 && <div>Действие {subscriptionEnding?.length == 1 ? "подписки" : "подписок"}{subscriptionEnding?.map(x => (<> {x.modemName} {' (' + x.daysLeft.toFixed() + " дней)"} </>))} заканчивается</div> }
                                { subscriptionExpire?.length > 0 && <div>{subscriptionExpire?.length == 1 ? "Закончилась подписка" : "Закончились подписки"}{subscriptionExpire?.map(x => (<> {x.modemName} </>))}</div> }
                            </> 
                        }

                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="primary" onClick={() => {window.location.href = "/subscriptions"}}>
                        {/*t('continue')*/} Управление подписками
                    </Button>
                    <Button variant="secondary" onClick={() => {setShowWarning(false)}}>
                        {/*t('close')*/}Закрыть
                    </Button>
                    </Modal.Footer>
                </Modal>
            </> : <></>}
        </>
    );
}

export default SubscriptionNotification;